export default function Result({ billAmount, tip }) {
    const total = billAmount + tip
    return (
        <p className="mt-4 text-xl font-bold">
            You pay {total} ({billAmount} + {tip} tip)
        </p>
    )
}
